import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CustomButtonActionService } from 'custom-button-action';
import { take } from 'rxjs/operators';
import { TalentEditDetailsService } from 'talent-edit-details';

@Component({
  selector: 'app-fb-page-title-parent-action-button',
  templateUrl: './fb-page-title-parent-action-button.component.html',
  styleUrls: ['./fb-page-title-parent-action-button.component.scss']
})
export class FbPageTitleParentActionButtonComponent implements OnChanges, OnInit {
  @Input() pageFormType: string;
  @Input() formBuilderInfo: any;
  @Input() showSimpleForm: boolean;
  @Output() pageFormButtonClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private customButtonActionService: CustomButtonActionService,
    private TalentEditDetailsService: TalentEditDetailsService
  ) { }

  ngOnChanges(): void {
    if (this.formBuilderInfo) {
      const fbRoleId = 'fbRoleId' in sessionStorage ? Number(sessionStorage.getItem('fbRoleId')) : null;
      const formButtons = this.formBuilderInfo.formBuilderPageFormButtons || [];
      this.formBuilderInfo = {
        ...this.formBuilderInfo,
        formBuilderPageFormButtons: formButtons.filter(x => x.name && String(x.name).trim() !== '' && (!x.customButtonJson || !(JSON.parse(x.customButtonJson).selectedRoles?.length) || JSON.parse(x.customButtonJson).selectedRoles.includes(fbRoleId)))
      };
    }

  }
  ngOnInit() {
    if (this.TalentEditDetailsService.bulkuploadbackclickflag == 'back') {
      this.pageFormButtonClick(this.formBuilderInfo.formBuilderPageFormButtons[1]);
      this.TalentEditDetailsService.bulkuploadbackclickflag = '';
    }
  }

  pageFormButtonClick(item: any) {
    if (item.isRedirectToAnotherForm && item.redirectPageFormId) {
      this.handleRedirect(item.redirectPageFormId);
    } else {
      const temp = {
        ...item,
        isCreateNew: true
      }
      this.pageFormButtonClicked.next(temp);
    }

  }
  handleRedirect(pageFormId: number) {
    this.customButtonActionService.getPageFormById(pageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          };
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }

}
